import { BaseDto } from "src/dtos/common/baseDto";

/** hrm_code_attend의 API 필드와 그리드의 신규·수정 상태를 표현한다. */
export interface HrmCodeAttendDto extends BaseDto {
    attendCd: string;
    attendNm: string;
    attendGroup: string;
    useYn: string;
    workYn: string;
    sortSeq: number;
    remark: string;
    inserted: boolean;
    isModified: boolean;
}

/** 신규 행의 사용·근무인정을 Y로 시작하도록 하는 엔티티 DTO 기본값이다. */
export const defaultHrmCodeAttendDto: HrmCodeAttendDto = {
    valueIndex: 0,
    orderIndex: 0,
    orderIndexSeq: 0,
    attendCd: '',
    attendNm: '',
    attendGroup: '',
    useYn: 'Y',
    workYn: 'Y',
    sortSeq: 0,
    remark: '',
    inserted: false,
    isModified: false,
};
